import type { MigrationRow } from "./types";
import type { MigrationsListQueryQueryType } from "@/types/graphql/admin.generated";

/**
 * Мапперы для feature управления миграциями
 */

export function getTableData(data: unknown): {
  nodes: MigrationRow[];
  count: number;
} {
  const migrations = (data as MigrationsListQueryQueryType)?.migrations;

  if (!migrations || !migrations.nodes) {
    return { nodes: [], count: 0 };
  }

  return migrations;
}

export function mapColumns(migration: MigrationRow) {
  return [
    migration.id,
    [migration.title, migration.id],
    migration.status,
    migration.attemptsMade || 0,
    migration.createdAt,
    migration.lastRunAt,
  ];
}
